export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "accordionplus";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			this.summary = this.$el.querySelector("summary");
			this.content = this.$el.querySelector(".tab-accordion-content");
			this.animation = null;
			this.isClosing = false;
			this.isExpanding = false;
			this.summary.addEventListener("click", (e) => this.onClick(e));
		}
	}

	onClick(e) {
		e.preventDefault();
		this.$el.style.overflow = 'hidden';
		if (this.isClosing || !this.$el.open) {
			this.open();
		} else if (this.isExpanding || this.$el.open) {
			this.shrink();
		}
	}
	
	shrink() {
		this.isClosing = true;
		const startHeight = `${this.$el.offsetHeight}px`;
		const endHeight = `${this.summary.offsetHeight}px`;
		if (this.animation) {
		  this.animation.cancel();
		}
		
		this.animation = this.$el.animate(
			{
				height: [startHeight, endHeight],
			},
			{
				duration: 150,
				easing: "ease-out",
			}
		);
		
		this.animation.onfinish = () => this.onAnimationFinish(false);
		this.animation.oncancel = () => this.isClosing = false;
	}
	
	open() {
		this.$el.style.height = `${this.$el.offsetHeight}px`;
		this.$el.open = true;
		window.requestAnimationFrame(() => this.expand());
	}
	
	expand() {
		this.isExpanding = true;
		const startHeight = `${this.$el.offsetHeight}px`;
		const endHeight = `${
			this.summary.offsetHeight + this.content.offsetHeight
		}px`;

		if (this.animation) {
			this.animation.cancel();
		}

		this.animation = this.$el.animate(
			{
				height: [startHeight, endHeight],
			},
			{
				duration: 200,
				easing: "ease-out",
			}
		);
		this.animation.onfinish = () => this.onAnimationFinish(true);
		this.animation.oncancel = () => (this.isExpanding = false);
	}
	
	onAnimationFinish(open) {
		this.$el.open = open;
		this.animation = null;
		this.isClosing = false;
		this.isExpanding = false;
		this.$el.style.height = this.$el.style.overflow = "";
	}
}
